export default __webpack_public_path__ + "static/media/filter-icon.e9bbd0ab.svg";